export const flyoutRowClass = (selected: boolean) =>
  [
    "flex w-full items-center justify-between gap-2 rounded px-2 py-1.5 text-left text-[13px] outline-none focus-visible:ring-2 focus-visible:ring-[var(--layout-side-nav-active-bg)]",
    selected
      ? "bg-[var(--layout-side-nav-active-bg)] text-white hover:bg-[var(--layout-side-nav-active-bg)]"
      : "hover:bg-slate-100 focus-visible:bg-slate-100",
  ].join(" ");
